import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            restaurantFilters: 'site/restaurantFilters',
            currency: 'site/currency',
        }),
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
        filters() {
            return [
                {
                    label: this.$t('restaurant.favourite'),
                    model: 'favourite',
                    hide: !this.isLoggedIn,
                    key: 'user_favorite',
                },
                {
                    label: this.$t('restaurant.ordered_already'),
                    model: 'alreadyOrdered',
                    hide: !this.isLoggedIn,
                    key: 'already_ordered_from',
                },
                {
                    label: this.$t('restaurant.delivery_in', {
                        min: this.restaurantFilters?.max_delivery_time,
                    }),
                    model: 'maxDeliveryTime',
                    key: 'max_delivery_time',
                },
                {
                    label: this.$t('restaurant.delivery_under', {
                        cost: this.$options.filters.toCurrency(
                            this.restaurantFilters?.max_delivery_price,
                            this.currency.locale,
                            this.currency.code
                        ),
                    }),
                    model: 'maxDeliveryPrice',
                    key: 'max_delivery_price',
                },
            ]
        },
    },
}
